import React, { useState, useEffect } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { DataTable } from "../../../components/tables";
import { projectDataGridCols } from "./ProjectDataGridCols";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import moment from "moment";
import { courses } from "../../../config";

const ProjectsData = () => {
  const [name, setName] = useState("");
  const [meetsData, setMeetsData] = useState([]);
  const navigate = useNavigate();
  const [selectCourse, setSelectCourse] = useState("");
  const [date, setDate] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [phone, setPhone] = useState("");

  const handleCancel = () => {
    setName("");
    setPhone(""); 
    setDate("");
    setFilteredStudents(meetsData);
  };
  const handleSearch = () => {
    const filteredData = meetsData.filter((student: any) => {
      const nameMatch = student.name.toLowerCase().includes(name.toLowerCase());
      const phoneMatch = phone ? student.phone.includes(phone) : true;

      const dateMatch = date
        ? moment(student.createdAt).format("YYYY-MM-DD") === date
        : true;

      const courseMatch = selectCourse
        ? student.courseName === selectCourse
        : true;

      return nameMatch && phoneMatch && dateMatch && courseMatch;
    });

    setFilteredStudents(filteredData);
  };
  const handleCreateMeet = () => {
    navigate("/support/createproject");
  };
  useEffect(() => {
    getMeets();
  }, []);

  const getMeets = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.allProjectData(data).then((res: any) => {
      if (res.status === "Success") {
        const formattedData = res?.data.map((item: any) => ({
          ...item,
          createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
        }));
        setMeetsData(formattedData);
        setFilteredStudents(formattedData);
      } else {
        toast.error(res.message);
      }
    });
  };

  const deleteMeetInfo = (meetId: string) => {
    const payload = {
      pId: meetId,
    };
    AdminService.deleteProject(payload).then((res: any) => {
      if (res.status === "Success") {
        toast.success(res.message);
        getMeets();
      } else {
        toast.error(res.message);
      }
    });
  };
  const handleEditMeet = (data: any) => {
    navigate("/support/editProject", { state: data });
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <Header />
        </div>
        <div className="row">
          <div className="col-md-2 h-100 px-0">
            <Sidebar />
          </div>
          <div className="col-md-10 content-scroll content-bg px-3 py-3">
            <div className="row">
              <div className="col-md-10 mt-3">
                <label className="form-label d-flex justify-content-start text-start">
                  <b>Projects List</b>
                </label>
                <div className="d-flex">
                  <input
                    name="User Name"
                    onChange={(e: any) => setName(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={name}
                    placeholder="Enter the User Name"
                  />
                  <input
                    type="phone" 
                    name="Phone"
                    onChange={(e: any) => setPhone(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={phone}
                    placeholder="Enter the Phone"
                  />
                  <input
                    type="date"
                    name="Date"
                    onChange={(e: any) => setDate(e.target.value)}
                    className="form-control mt-1 me-2"
                    value={date}
                  />
                  <select
                    className="form-select mt-1 me-2"
                    value={selectCourse}
                    onChange={(e: any) => setSelectCourse(e.target.value)}
                  >
                    <option>Select Courses</option>
                    {courses.map((ele: any, index) => {
                      return (
                        <option value={ele.name} key={index}>
                          {ele.name}
                        </option>
                      );
                    })}
                  </select>
                  <button
                    className="btn btn-primary rounded px-4 py-1 ms-3"
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    className="btn btn-secondary rounded ms-2 px-4 py-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
              <div className="col-md-6 mt-3">
                {/* <div className="text-end">
                  <button
                    className="btn btn-success"
                    onClick={handleCreateMeet}
                  >
                    Create Project
                  </button>
                </div> */}
              </div>
            </div>
            <div className="mt-5">
              <DataTable
                tableData={filteredStudents}
                TableCols={projectDataGridCols}
                deleteMeetInfo={deleteMeetInfo}
                handleEditMeet={handleEditMeet}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsData;
